import endOfToday from 'date-fns/endOfToday';
import endOfTomorrow from 'date-fns/endOfTomorrow';
import endOfWeek from 'date-fns/endOfWeek';
import endOfYesterday from 'date-fns/endOfYesterday';
import startOfToday from 'date-fns/startOfToday';
import startOfTomorrow from 'date-fns/startOfTomorrow';
import startOfWeek from 'date-fns/startOfWeek';
import startOfYesterday from 'date-fns/startOfYesterday';
import isEqual from 'lodash-es/isEqual';
import { BoardFilterDateRange, DateRangeOutput } from 'shared/types/graphql';

const date = new Date();

const dateLimits = {
  startOfYesterday: startOfYesterday().toISOString(),
  endOfYesterday: endOfYesterday().toISOString(),
  startOfToday: startOfToday().toISOString(),
  endOfToday: endOfToday().toISOString(),
  startOfTomorrow: startOfTomorrow().toISOString(),
  endOfTomorrow: endOfTomorrow().toISOString(),
  startOfWeek: startOfWeek(date, { weekStartsOn: 1 }).toISOString(),
  endOfWeek: endOfWeek(date, { weekStartsOn: 1 }).toISOString(),
};

type DateRangeMap = Record<BoardFilterDateRange, DateRangeOutput>;
export const dateRangeMap: DateRangeMap = {
  [BoardFilterDateRange.Yesterday]: {
    gte: dateLimits.startOfYesterday,
    lte: dateLimits.endOfYesterday,
  },
  [BoardFilterDateRange.Tomorrow]: {
    gte: dateLimits.startOfTomorrow,
    lte: dateLimits.endOfTomorrow,
  },
  [BoardFilterDateRange.ThisWeek]: {
    gte: dateLimits.startOfWeek,
    lte: dateLimits.endOfWeek,
  },
  [BoardFilterDateRange.Today]: {
    gte: dateLimits.startOfToday,
    lte: dateLimits.endOfToday,
  },
};

export const mapDateToPredefinedOption = (dateRange: { gte: string; lte: string }): BoardFilterDateRange | null => {
  const dateOptions: BoardFilterDateRange[] = Object.keys(dateRangeMap) as BoardFilterDateRange[];

  const mappedOption = dateOptions.find((option: BoardFilterDateRange) => {
    if (isEqual(dateRange, dateRangeMap[option])) {
      return option;
    }
  });

  return mappedOption || null;
};
